import { getHeaders } from "js/Api";
import { languages, translateBehavior } from "js/Constants/common";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const TranslationSettingsTab = () => {
    const [userInfo, setUserInfo] = useState(null);

    const [preferredLang, setPreferredLang] = useState();

    const [langBehaviour, setLangBehaviour] = useState();

    useEffect(() => {
        const storedUserInfo = localStorage.getItem("userInfo");
        if (storedUserInfo) {
            try {
                const parsedUserInfo = JSON.parse(storedUserInfo);
                setUserInfo(parsedUserInfo);
                setPreferredLang(parsedUserInfo?.preferredLang);
                setLangBehaviour(parsedUserInfo?.translateBehaviour);
            } catch (error) {
                console.error("Error parsing userInfo:", error);
                localStorage.removeItem("userInfo");
            }
        }
    }, []);


    const handlePreferredLang = (event) => {
        setPreferredLang(event.target.value);
    }

    const handleTranslationBehaviour = (event) => {
        setLangBehaviour(event.target.value);
    }

    const handleApplyBtn = async () => {
        try {
            const params = {
                "preferredLang": preferredLang,
                "translateBehaviour": langBehaviour
            };
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/update_user/${userInfo?.userId}`,
                {
                    method: "PUT",
                    headers: getHeaders(),
                    body: JSON.stringify(params),
                    credentials: "include",
                }
            );

            if (response.ok) {
                userInfo.preferredLang = preferredLang;
                userInfo.translateBehaviour = langBehaviour;
                setUserInfo(userInfo);
                localStorage.setItem("userInfo", JSON.stringify(userInfo));
                toast.success("Translation settings updated successfully!");
                return { success: true, message: "Translation settings updated successfully!" };
            } else if (response.status === 400) {
                toast.error("Oops! Something went wrong.");
                return {
                    success: false,
                    error: "Oops! Something went wrong."
                };
            } else {
                return { success: false, error: "Failed to update the translation settings" };
            }
        } catch (error) {
            return {
                success: false,
                error: "An error occurred while updating the translation settings"
            };
        }
    }

    return (
        <div>
            <div className="row">
                <div className="form-group col-md-4">
                    <label htmlFor="language">Your Preferred Spoken Language</label>
                    <select
                        className="form-control"
                        id="language"
                        name="language"
                        value={preferredLang}
                        onChange={handlePreferredLang}
                        required
                    >
                        {languages.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.key}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4">
                    <label htmlFor="langBehaviour">Default Translation Behaviour</label>
                    <select
                        className="form-control"
                        id="langBehaviour"
                        name="langBehaviour"
                        value={langBehaviour}
                        onChange={handleTranslationBehaviour}
                        required
                    >
                        {translateBehavior.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.key}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <button onClick={handleApplyBtn} type="button" className="btn cur-p btn-dark" style={{ marginBottom: "20px" }} > Apply </button>
        </div>
    )
}

export default TranslationSettingsTab;